exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tobacco legend,.tobacco .MuiTypography-root{color:#343a40}.tobacco.small-label>div>fieldset>legend,.tobacco .MuiTypography-root{font-size:.85rem;line-height:1.25}.tobacco label{margin-bottom:0}.tobacco .MuiButtonBase-root{padding:4px 9px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/SubComponents/TobaccoRadio.scss
// module id = 7823
// module chunks = 13